import { render, staticRenderFns } from "./documentDirectory.vue?vue&type=template&id=fe2a4988&scoped=true&"
import script from "./documentDirectory.vue?vue&type=script&lang=js&"
export * from "./documentDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2a4988",
  null
  
)

export default component.exports